import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CsatModalService } from '@sd-portal/shared/csat';
import { LoaderService } from '@sd-portal/shared/shell';
import { forkJoin, of } from 'rxjs';
import { catchError, map, switchMap, switchMapTo, tap } from 'rxjs/operators';
import * as csatActions from './csat.actions';

@Injectable()
export class CsatEffects {

  getQuestions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(csatActions.getQuestionsInfo),
      switchMapTo(forkJoin([this.csatModalService.getUserAnswerLastDate(), this.csatModalService.getQuestions()])),
      map(data => csatActions.getQuestionsInfoSuccess({
        lastAnswerDate: data[0].lastAnswerDate,
        questionsList: data[1].satisfactionQuestionsList
      })),
      catchError(() => of(csatActions.getQuestionsInfoError()))
    )
  );

  saveUserAnswer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(csatActions.saveUserAnswer),
      tap(() => this.loaderService.showGlobalLoader(true)),
      switchMap(action =>
        this.csatModalService.saveUserAnswer(action).pipe(
          map(_ => {
            csatActions.saveUserAnswerSuccess();
            this.csatModalService.showConfirmBlock.next(true);
            setTimeout(() => {
              this.csatModalService.setOpenModal(false);
            }, 5000);
          }),
          catchError(() => of(csatActions.saveUserAnswerError()))
        )
      ),
      tap(() => this.loaderService.hideGlobalLoader())
    ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private readonly csatModalService: CsatModalService,
    private readonly loaderService: LoaderService
  ) {
  }
}
